<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						{{config.mode=="modify"?'강의 목차 수정':'새 강의 목차'}}
					</h2>
					<a class="close" @click="config.show=false">&times;</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 white-box clearfix">
					<p class="f-14 m-b-5">
						강의 목차명
					</p>
					<input v-model="curriculum.name" class="form-control round full-width m-b-30" type="text" placeholder="강의 목차명을 입력해 주세요.">
				</div>

				<div class="white-box clearfix">
					<p class="f-14 m-b-5">
						수료처리 여부
					</p>
					<div class="input-group m-b-10 full-width">
						<span class="input-group-addon">
							<input id="chkFinishEnable0" class="checkbox3-sm" type="radio" value="0" v-model="curriculum.finishEnable">
							<label for="chkFinishEnable0" class="v-mid full-width">수료없음</label>
						</span>
						<span class="input-group-addon p-l-5">
							<input id="chkFinishEnable1" class="checkbox3-sm" type="radio" value="1" v-model="curriculum.finishEnable">
							<label for="chkFinishEnable1" class="v-mid full-width">수료있음</label>
						</span>
					</div>
				</div>
				<div class="white-box clearfix" v-if="curriculum.finishEnable==1">
					<p class="f-14 m-b-5">
						수료기준
					</p>
					<div class="input-group w200">
						<span class="input-group-addon">
							<input id="check3" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishEnable">
							<label for="check3" class="v-mid full-width">자동수료</label>
						</span>
					</div>
					<p class="help-text m-t-5">- 자동수료 선택시 익일 3시에 자동 수료처리 됩니다.</p>
					<div class="half-width pull-left">
						<div class="input-group m-b-10">
							<span class="input-group-addon w140">
								<input id="c-1" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='전체진도율').enabled">
								<label for="c-1" class="v-mid full-width">전체진도율</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<input class="form-control-sm round v-mid m-b-0" type="text" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='전체진도율').value">
							</span>
							<span class="input-group-addon">%</span>
						</div>
						<div class="input-group m-b-10">
							<span class="input-group-addon w140">
								<input id="c-2" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='차시별 재생시간').enabled">
								<label for="c-2" class="v-mid full-width">동영상 재생시간</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<input class="form-control-sm round v-mid m-b-0" type="text" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='차시별 재생시간').value">
							</span>
							<span class="input-group-addon">분</span>
						</div>
						<div class="input-group">
							<span class="input-group-addon w140">
								<input id="c-3" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='성적').enabled">
								<label for="c-3" class="v-mid full-width">시험응시</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<select v-model="curriculum.autoFinishCondi__.find(c=>c.name=='성적').value">
									<option value="1">반드시 모든 시험 응시</option>
									<option value="0">응시여부 확인 안함</option>
								</select>
							</span>
						</div>
					</div>
					<div class="half-width pull-left">
						<div class="input-group m-b-10">
							<span class="input-group-addon w140">
								<input id="c-4" class="checkbox3-sm" type="checkbox" alue="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='출석').enabled">
								<label for="c-4" class="v-mid full-width">출석</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<input class="form-control-sm round v-mid m-b-0" type="text" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='출석').value">
							</span>
							<span class="input-group-addon">%</span>
						</div>
						<div class="input-group  m-b-10">
							<span class="input-group-addon w140">
								<input id="c-5" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='과제').enabled">
								<label for="c-5" class="v-mid full-width">과제</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<input class="form-control-sm round v-mid m-b-0" type="text" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='과제').value">
							</span>
							<span class="input-group-addon">건</span>
						</div>
						<div class="input-group">
							<span class="input-group-addon w140">
								<input id="c-6" class="checkbox3-sm" type="checkbox" value="1" v-model="curriculum.autoFinishCondi__.find(c=>c.name=='설문').enabled">
								<label for="c-6" class="v-mid full-width">설문응답</label>
							</span>
							<span class="input-group-addon p-l-5 v-mid">
								<select v-model="curriculum.autoFinishCondi__.find(c=>c.name=='설문').value">
									<option value="1">반드시 모든 설문 응답</option>
									<option value="0">응답여부 확인 안함</option>
								</select>
							</span>
						</div>
					</div>
				</div>
				<div class="white-box clearfix" v-if="curriculum.finishEnable==1">
					<p class="f-14 m-b-5">
						수료안내
					</p>
					<div class="round">
						<textarea class="full-width" cols="30" rows="4" v-model="curriculum.finishInfo"></textarea>
					</div>
				</div>
				<div class="white-box clearfix" v-if="curriculum.finishEnable==1">
					<p class="f-14 m-b-5">
						수료증 양식 선택
					</p>
					<div class="input-group full-width">
						<span class="input-group-addon p-r-5">
							<select class="form-control-sm m-b-0 round full-width" v-model="curriculum.certForm">
								<option value="">수료증을 발급하지 않음</option>
								<option value="기본">기본 수료증 양식</option>
							</select>
						</span>
						<span class="input-group-addon w200 v-mid">
							<button class="btn-sm bg-blue text-white round full-width" type="button" v-show="curriculum.certForm">미리보기</button>
						</span>
					</div>
				</div>
				<!-- //end .modal-body -->
				<div class="modal-footer p-10">
					<button @click="register" class="btn bg-deepblue text-white full-width m-t-30 round" type="button">{{config.mode=="modify"?'수정하기':'만들기'}}</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios'
import server from '../statics/server.js'

export default {
	name: "ModalCurriculumRegister",

	default: function() {
		return {
			name: this.name,
			show: false,
			lecId: 0,
			lecName: "",
			mode: "register",
			old: null
		}
	},

	mounted: function() {
		let that = this;
		this.editorFinishInfo = new window.FroalaEditor("#editInModalCirruciulumRegister", {
			imageUploadParam: 'file',
			imageUploadURL: `${server.addr()}${server.api.FILE}`,
			imageUploadMethod: 'POST',
			imageAllowedTypes: ['jpeg', 'jpg', 'png'],
			events: {
				'image.beforeUpload': function (images) {
					const formData = new FormData();
					formData.append("file", images[0]);
					axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						Array.from(window.document.getElementsByClassName("fr-popup")).forEach((e) => {e.setAttribute("class", e.getAttribute("class").replace("fr-active",""))});
						this.image.insert("/download/"+response.data);
					});
					return false;
				},
				'image.error': function() { },
				"contentChanged": function() {
					that.content = this.html.get();
				},
				"initialized": function() {
					this.html.set(that.content);
				}
			},
		})

		if(this.config.mode=="modify" && this.config.old) {
			this.curriculum.name = this.config.old.name;
			this.curriculum.lecId = this.config.old.lecId;
			this.curriculum.finishEnable = this.config.old.finishEnable;
			this.curriculum.autoFinishCondi__ = JSON.parse(this.config.old.autoFinishCondi);
			this.curriculum.autoFinishCondi = this.config.old.autoFinishCondi;
			if(!this.curriculum.autoFinishCondi.find(e=>e.name=="설문")) this.curriculum.autoFinishCondi.push({name:"설문", enabled:false, value:0});
			this.curriculum.finishInfo = this.config.old.finishInfo;
			this.curriculum.certForm = this.config.old.certForm;
			this.curriculum.lesList = this.config.old.lesList;
		}
	},

	data: function() {
		return  {
			curriculum: {
				name: this.config.lecName,
				lecId: this.config.lecId,
				finishEnable: 0,
				autoFinishEnable: 0,
				autoFinishCondi__: [
					{name:"전체진도율", enabled:false, value:0},
					{name:"차시별 재생시간", enabled:false, value:0},
					{name:"성적", enabled:false, value:0},
					{name:"출석", enabled:false, value:0},
					{name:"과제", enabled:false, value:0},
					{name:"설문", enabled:false, value:0},
				],
				autoFinishCondi: "",
				finishInfo: "",
				certForm: "",
				lesList: [],
			},
			editorFinishInfo: null
		}
	},

	props: {
		config: Object
	},

	methods: {
		register: function() {
			if(this.config.mode=="register") {
				this.curriculum.autoFinishCondi = JSON.stringify(this.curriculum.autoFinishCondi__);
				if(this.curriculum.autoFinishEnable) this.curriculum.autoFinishEnable = "1";
				else this.curriculum.autoFinishEnable = "0";
				axios.put(server.addr()+server.api.CURRICULUM, [this.curriculum]).then( (response) => {
					if(response.status==200) {
						this.$emit("CurriculumSelected", response.data.list);
						this.config.show = false;
					}
				});
			} else {
				this.curriculum.autoFinishCondi = JSON.stringify(this.curriculum.autoFinishCondi__);
				if(this.curriculum.autoFinishEnable) this.curriculum.autoFinishEnable = "1";
				else this.curriculum.autoFinishEnable = "0";
				axios.patch(server.addr()+server.api.CURRICULUM+"/"+this.config.old.curriculumId, this.curriculum).then( (response) => {
					if(response.status==200) {
						this.$emit("CurriculumModified", response.data.list);
						this.config.show = false;
					}
				});
			}
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>